export default(key, lang) => {
  let mapping = {
    title: {
      en_US: 'Your Account Is Insecure',
      de_DE: 'Ihr Konto ist Unsicher',
      el_GR: 'Ο λογαριασμός σας είναι ανασφαλής',
      es_ES: 'Tu Cuenta es Insegura',
      fr_FR: "Votre compte n'est pas sécurisé",
      fr_CA: "Votre compte n'est pas sécurisé",
      it_IT: 'Il tuo Account non è Sicuro',
      pl_PL: 'Twoje konto jest niepewne',
      th_TH: 'บัญชีของคุณไม่ปลอดภัย',
      zh_CN: '您的帐户不安全',
      pt_BR: 'Sua conta é insegura',
      ja_JP: 'あなたのアカウントは安全ではありません',
    },
    submitText: {
      en_US: 'Secure My Account',
      de_DE: 'Mein Konto Sichern',
      el_GR: 'Ασφαλίστε τον λογαριασμό μου',
      es_ES: 'Asegure Mi Cuenta',
      fr_FR: 'Sécuriser mon compte',
      fr_CA: 'Sécuriser mon compte',
      it_IT: 'Proteggi il mio account',
      pl_PL: 'Zabezpiecz moje konto',
      th_TH: 'รักษาความปลอดภัยบัญชีของฉัน',
      zh_CN: '保护我的帐户',
      pt_BR: 'Proteger minha conta',
      ja_JP: 'アカウントを保護する',
    },
    cancelText: {
      en_US: 'Remain Insecure',
      de_DE: 'Unsicher Bleiben',
      el_GR: 'Παραμείνετε ανασφαλείς',
      es_ES: 'Permanecer Inseguro',
      fr_FR: 'Rester insécurisé',
      fr_CA: 'Rester insécurisé',
      it_IT: 'Rimanere insicuro',
      pl_PL: 'Pozostań niepewny',
      th_TH: 'ยังไม่ปลอดภัย',
      zh_CN: '保持不安全感',
      pt_BR: 'Permaneça inseguro',
      ja_JP: '安全でないまま',
    },
    mfaDescription: {
      en_US: 'Multi-Factor Authentication will be required starting March 31st, 2020. At that time, you will no longer be able to remain insecure. Are you sure you want to leave your account and data in a less secure state?',
      de_DE: 'Ab dem 31. März 2020 ist eine Multi-Faktor-Authentifizierung erforderlich. Zu diesem Zeitpunkt können Sie nicht mehr unsicher bleiben. Sind Sie sicher, dass Sie Ihr Konto und Ihre Daten in einem weniger sicheren Zustand belassen möchten?',
      el_GR: 'Ο έλεγχος ταυτότητας πολλαπλών παραγόντων θα χρειαστεί από τις 31 Μαρτίου 2020. Εκείνη την εποχή, δεν θα είστε πλέον σε θέση να παραμείνετε ανασφαλείς. Είστε βέβαιοι ότι θέλετε να αφήσετε το λογαριασμό και τα δεδομένα σας σε λιγότερο ασφαλής κατάσταση;',
      es_ES: 'Se requerirá la autenticación multifactor a partir del 31 de marzo de 2020. En ese momento, ya no podrá permanecer inseguro. ¿Está seguro de que desea dejar su cuenta y sus datos en un estado menos seguro?',
      fr_FR: 'Une authentification multifacteur sera requise à partir du 31 mars 2020. À ce moment, vous ne pourrez plus rester en sécurité. Voulez-vous vraiment laisser votre compte et vos données dans un état moins sécurisé?',
      fr_CA: 'Une authentification multifacteur sera requise à partir du 31 mars 2020. À ce moment, vous ne pourrez plus rester en sécurité. Voulez-vous vraiment laisser votre compte et vos données dans un état moins sécurisé?',
      it_IT: "L'autenticazione a più fattori sarà richiesta a partire dal 31 marzo 2020. A quel tempo, non sarai più in grado di rimanere insicuro. Sei sicuro di voler lasciare il tuo account e i tuoi dati in uno stato meno sicuro?",
      pl_PL: 'Uwierzytelnianie wieloskładnikowe będzie wymagane od 31 marca 2020 r. W tym momencie nie będziesz już mógł być niepewny. Czy na pewno chcesz pozostawić swoje konto i dane w mniej bezpiecznym stanie?',
      th_TH: 'ต้องมีการรับรองความถูกต้องแบบหลายปัจจัยตั้งแต่วันที่ 31 มีนาคม 2563 ในเวลานั้นคุณจะไม่สามารถอยู่ได้อย่างปลอดภัยอีกต่อไป คุณแน่ใจหรือไม่ว่าต้องการออกจากบัญชีและข้อมูลของคุณในสถานะที่ปลอดภัยน้อยลง?',
      zh_CN: '从2020年3月31日开始，将需要多因素身份验证。届时，您将不再能够保持不安全感。您确定要让帐户和数据处于不太安全的状态吗？',
      pt_BR: 'A autenticação multifator será necessária a partir de 31 de março de 2020. Nesse momento, você não poderá mais permanecer inseguro. Tem certeza de que deseja deixar sua conta e dados em um estado menos seguro?',
      ja_JP: '2020年3月31日以降、多要素認証が必要になります。その時点で、セキュリティで保護された状態を維持できなくなります。アカウントとデータを安全性の低い状態のままにしておきますか？',
    },
  };

  return mapping[key][lang];
};